var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.0181,
    cy: 54.79,
    r: 53.0991,
    stroke: "#CE1111",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5628 35.5C66.5628 38.5666 65.3446 41.5075 63.1762 43.6759C61.0078 45.8443 58.0669 47.0625 55.0003 47.0625C51.9338 47.0625 48.9928 45.8443 46.8244 43.6759C44.656 41.5075 43.4378 38.5666 43.4378 35.5C43.4378 32.4334 44.656 29.4925 46.8244 27.3241C48.9928 25.1557 51.9338 23.9375 55.0003 23.9375C58.0669 23.9375 61.0078 25.1557 63.1762 27.3241C65.3446 29.4925 66.5628 32.4334 66.5628 35.5ZM31.8784 79.0305C31.9775 72.9636 34.4571 67.1786 38.7825 62.9233C43.108 58.6679 48.9326 56.2831 55.0003 56.2831C61.068 56.2831 66.8927 58.6679 71.2181 62.9233C75.5435 67.1786 78.0231 72.9636 78.1222 79.0305C70.8694 82.3597 62.9808 84.0765 55.0003 84.0625C46.7493 84.0625 38.9177 82.2618 31.8784 79.0305Z",
    stroke: "#CE1111",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0cfcb749f8bbfdf30e15b9799e1449f0.svg";
export { ForwardRef as ReactComponent };